export const expandCollapseFragment = `
  fragment expandCollapseFragment on ExpandCollapseModuleRecord {
    allOpen
    button {
      ...buttonFragment
    }
    cards {
      ...expandCollapseCardFragment
    }
    faqPageStructuredData
    filter
    filterPlaceholder
    headingProps {
      textStyle
    }
    moduleFormat {
      ...moduleFormatFragment
    }
    subtitle
    title
  }

  fragment expandCollapseCardFragment on ExpandCollapseCardRecord {
    button {
      ...buttonFragment
    }
    content {
      blocks {
        ... on ListWithIconsBlockRecord {
          ...listWithIconsFragment
        }
      }
      links
      value
    }
    filterValues
    image {
      responsiveImage(
        imgixParams: {
          auto: format,
          fit: clip,
          h: 42,
          q: 45
        }
      ) {
        ...responsiveImageFragment
      }
    }
    title
  }
`;
